import { Settings } from 'lucide-react'

export function SettingsPage() {
  return (
    <div className='flex flex-col items-center justify-center gap-4 py-24 text-center'>
      <div className='flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-100'>
        <Settings className='h-8 w-8 text-gray-500' />
      </div>
      <h1 className='text-xl font-semibold text-gray-800'>Settings</h1>
      <p className='text-sm text-gray-400'>Application settings coming soon.</p>
    </div>
  )
}
